const INFINITE_SCROLL_LOADING_DOTS_HTML = `<span class="infinite-scroll__loading-dots" aria-hidden="true"><span class="infinite-scroll__loading-dot"></span><span class="infinite-scroll__loading-dot"></span><span class="infinite-scroll__loading-dot"></span></span>`;

export class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.anchor = this.querySelector("a");
    if (!this.anchor) return;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadNextPage();
        }
      });
    });

    this.observer.observe(this);
  }

  async loadNextPage() {
    this.observer.disconnect();

    this.anchor.style.display = "flex";
    this.anchor.style.alignItems = "center";
    this.anchor.style.justifyContent = "center";
    this.anchor.style.cursor = "wait";
    const loadMore =
      this.anchor.dataset.loadMoreLabel || "Load more products";
    const loading =
      this.anchor.dataset.loadingLabel || "Loading more products";

    this.anchor.setAttribute("aria-busy", "true");
    this.anchor.setAttribute("aria-label", loading);
    this.anchor.innerHTML = INFINITE_SCROLL_LOADING_DOTS_HTML;

    const url = this.anchor.dataset.href || this.anchor.getAttribute("href");
    if (!url) {
      this.anchor.removeAttribute("aria-busy");
      this.anchor.setAttribute("aria-label", loadMore);
      this.anchor.textContent = "";
      this.anchor.style.display = "none";
      return;
    }

    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, "text/html");

      // Grab the product grid from the next page
      const newGrid = html.querySelector("[data-product-grid]");
      const grid = document.querySelector("[data-product-grid]");

      if (newGrid && grid) {
        Array.from(newGrid.children).forEach((child) => {
          grid.appendChild(child);
        });
      }

      // Handle next infinite scroll
      const newInfinite = html.querySelector("infinite-scroll");
      if (newInfinite) {
        this.replaceWith(newInfinite);
      } else {
        this.remove();
      }
    } catch (err) {
      console.error("InfiniteScroll error:", err);
    }

    this.anchor.removeAttribute("aria-busy");
    this.anchor.setAttribute("aria-label", loadMore);
    this.anchor.innerHTML = "";
    this.anchor.style.display = "none";
    this.anchor.style.cursor = "";
  }
}

if (!customElements.get("infinite-scroll")) {
  customElements.define("infinite-scroll", InfiniteScroll);
}
